// @flow

import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {IconButton, makeStyles} from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';

import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import OptionChip from '../OptionChip/OptionChip';
import {colors} from '../../../../../assets/styles/colors';

import type {Theme} from '@material-ui/core';

type Props = {
  options: string[],
  // handleRemove: (val: string) => void,
  setOptions: (string[] | ((string[]) => string[])) => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  optionsList: {
    margin: theme.spacing(1, 0),
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  iconButton: {
    padding: theme.spacing(1),
    background: `${colors.purple3}!important`,
  },
  icon: {
    color: '#FFFFFF',
  },
  optionFormWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
}));

export default function OptionsForm({options, setOptions}: Props) {
  const classes = useStyles();

  const [optionText, setOptionText] = useState<string>('');

  const handleAddOption = () => {
    if (optionText.trim().length > 0) {
      const exists = options.find(el => el === optionText);
      if (!exists) {
        setOptions(prev => [...prev, optionText]);
        setOptionText('');
      }
    }
  };

  const handleKeyDown = e => {
    const {keyCode} = e;
    if (keyCode === 13) {
      handleAddOption();
    }
  };

  const onInputChange = e => {
    setOptionText(e.target.value);
  };

  const onDeleteOption = (opt: string) => {
    setOptions(prev => prev.filter(el => el !== opt));
  };

  return (
    <div className={classes.optionFormWrap}>
      {options.length > 0 && (
        <div className={classes.optionsList}>
          {options.map(opt => (
            <OptionChip
              key={opt}
              label={opt}
              onDelete={() => onDeleteOption(opt)}
            />
          ))}
        </div>
      )}
      <CustomTextField
        onKeyDown={handleKeyDown}
        value={optionText}
        onChange={onInputChange}
        placeholder="Agregar opciones a la lista"
        InputProps={{
          endAdornment: (
            <IconButton
              className={classes.iconButton}
              onClick={handleAddOption}
            >
              <SendIcon className={classes.icon} fontSize="small" />
            </IconButton>
          ),
        }}
      />
    </div>
  );
}

OptionsForm.propTypes = {
  options: PropTypes.array.isRequired,
  // handleRemove: PropTypes.func.isRequired,
  setOptions: PropTypes.func.isRequired,
};
